module.exports = __webpack_public_path__ + "static/media/image6.f7fdc1dd.png";